import { Component } from '@angular/core';

@Component({
  selector: 'app-menu-management',
  standalone: false,
  templateUrl: './menu-management.component.html',
  styleUrl: './menu-management.component.css'
})
export class MenuManagementComponent {

  isModalOpen = false;

  successMessage = '';
  errorMessage = '';

  menuForm = {
    titleKh: '',
    titleEn: '',
    url: '',
    icon: '',
    parentMenu: '',
    level: 'main',
    status: 'visible'
  };

  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  saveMenu() {

    this.successMessage = '';
    this.errorMessage = '';

    if (!this.menuForm.titleEn || !this.menuForm.titleKh) {
      this.errorMessage = "Please fill all required fields.";
      return;
    }

    try {

      // simulate save
      console.log(this.menuForm);

      this.successMessage = "Menu saved successfully.";
      this.closeModal();

      setTimeout(() => {
        this.successMessage = '';
      }, 3000);

    } catch (error) {

      this.errorMessage = "Failed to save menu.";

    }
  }

}
